"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YETIStake = void 0;
const Decimal_1 = require("./Decimal");
/**
 * Represents a user's YETI stake and accrued gains.
 *
 * @remarks
 * Returned by the {@link ReadableLiquity.getYETIStake | getYETIStake()} function.

 * @public
 */
class YETIStake {
    /** @internal */
    constructor(stakedYETI = Decimal_1.Decimal.ZERO, collateralGain = Decimal_1.Decimal.ZERO, yusdGain = Decimal_1.Decimal.ZERO) {
        this.stakedYETI = stakedYETI;
        this.collateralGain = collateralGain;
        this.yusdGain = yusdGain;
    }
    get isEmpty() {
        return this.stakedYETI.isZero && this.collateralGain.isZero && this.yusdGain.isZero;
    }
    /** @internal */
    toString() {
        return (`{ stakedYETI: ${this.stakedYETI}` +
            `, collateralGain: ${this.collateralGain}` +
            `, yusdGain: ${this.yusdGain} }`);
    }
    /**
     * Compare to another instance of `YETIStake`.
     */
    equals(that) {
        return (this.stakedYETI.eq(that.stakedYETI) &&
            this.collateralGain.eq(that.collateralGain) &&
            this.yusdGain.eq(that.yusdGain));
    }
    /**
     * Calculate the difference between this `YETIStake` and `thatStakedYETI`.
     *
     * @returns An object representing the change, or `undefined` if the staked amounts are equal.
     */
    whatChanged(thatStakedYETI) {
        thatStakedYETI = Decimal_1.Decimal.from(thatStakedYETI);
        if (thatStakedYETI.lt(this.stakedYETI)) {
            return {
                unstakeYETI: this.stakedYETI.sub(thatStakedYETI),
                unstakeAllYETI: thatStakedYETI.isZero
            };
        }
        if (thatStakedYETI.gt(this.stakedYETI)) {
            return { stakeYETI: thatStakedYETI.sub(this.stakedYETI) };
        }
    }
    /**
     * Apply a {@link YETIStakeChange} to this `YETIStake`.
     *
     * @returns The new staked YETI amount.
     */
    apply(change) {
        if (!change) {
            return this.stakedYETI;
        }
        if (change.unstakeYETI !== undefined) {
            return change.unstakeAllYETI || this.stakedYETI.lte(change.unstakeYETI)
                ? Decimal_1.Decimal.ZERO
                : this.stakedYETI.sub(change.unstakeYETI);
        }
        else {
            return this.stakedYETI.add(change.stakeYETI);
        }
    }
}
exports.YETIStake = YETIStake;
//# sourceMappingURL=YETIStake.js.map